"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntryPatchAttributes = exports.INITIAL_SECTION_STATE = exports.INITIAL_MARK_STATE = exports.INITIAL_ENTRY_STATE = exports.sampleEntryDef = exports.mapToEntryBusinessUnitId = void 0;
const db_1 = require("./db");
const _1 = require(".");
const schemaValidator_1 = require("../util/schemaValidator");
const joi_1 = __importDefault(require("joi"));
const mapToEntryBusinessUnitId = (params) => ({
    'businessUnit.id': params.businessUnitId,
    centreId: params.centreId,
    seriesId: +params.seriesId,
    componentNumber: params.componentNumber,
    assessmentCode: params.assessmentCode,
    'learner.number': +params.learnerNumber,
});
exports.mapToEntryBusinessUnitId = mapToEntryBusinessUnitId;
exports.sampleEntryDef = Object.assign(Object.assign({}, db_1.entryDef), { substitutedFor: (0, schemaValidator_1.objectSchema)(db_1.learnerDef).optional(), type: joi_1.default.string() });
exports.INITIAL_ENTRY_STATE = {
    submitted: false,
    isResubmissionRequired: false,
};
exports.INITIAL_MARK_STATE = {
    isEpsOrigin: false,
};
exports.INITIAL_SECTION_STATE = {
    availableForTraining: false,
    missingWork: false,
    uploaded: false,
    submitted: false,
    isResubmissionRequired: false,
    submissionDate: null,
    assessmentState: _1.AssessmentState.NOT_READY_FOR_ASSESSMENT,
};
var EntryPatchAttributes;
(function (EntryPatchAttributes) {
    EntryPatchAttributes["MARK"] = "mark";
    EntryPatchAttributes["ABSENT"] = "absent";
})(EntryPatchAttributes = exports.EntryPatchAttributes || (exports.EntryPatchAttributes = {}));
